import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../../../features/components/Forms/StepForm/Step'
import ErrorMessage from '../../../../../../../../../components/Form/ErrorMessage'
import UnitsField from '../SingleAllocationTargetingEnabledStep/UnitsField'
import InventoryOverviewSpoiler from '../../../../../components/InventoryOverviewSpoiler'

import { useUnitTypeLabel } from '../../../../hooks/remainingBudgetHooks'
import { useLineItemForecastData } from '../SubAllocationInventoryTargetingStep/RightInventoryTable/SubAllocationMultiFieldItem/useLineItemForecastData'
import { getIsBudgetAllocationType } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { rightSelector } from '../../../../../../../../../modules/selectors/rights'

import { UNITS } from '../../../../fields'
import { AD_INVENTORY } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useDrawerFormStyles from '../../../../../../../../../styles/common/drawerForms'

const SingleAllocationTargetingDisabledStep = ({ formik }) => {
  const right = useSelector(rightSelector)

  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const { values } = formik

  const unitTypeLabel = useUnitTypeLabel()
  const allRightInventory = right[AD_INVENTORY]
  const billingEvent = right?.billing_event
  const firstInventory = allRightInventory?.[0]
  const microAmount = firstInventory?.prices?.[billingEvent]

  const { forecastErrorMessage } = useLineItemForecastData({
    values,
    inventory: allRightInventory,
    microAmount,
    units: values[UNITS],
    targetingEnabled: false
  })

  const isBudgetAllocationType = getIsBudgetAllocationType(right)

  const title = useMemo(() => {
    if (isBudgetAllocationType) {
      return t('What budget do you want to set for this line item?')
    } else {
      return t(`What ${unitTypeLabel} budget do you want to set for this line item?`)
    }
  }, [t, isBudgetAllocationType, unitTypeLabel])

  return (
    <Step stepTitle={title}>
      <InventoryOverviewSpoiler />
      <section className={drawerFormClasses.section}>
        <h4 className={drawerFormClasses.sectionTitle}>{t('Budget')}</h4>
        <UnitsField formik={formik} forecastErrorMessage={forecastErrorMessage} />
        {forecastErrorMessage && <ErrorMessage error={forecastErrorMessage} />}
      </section>
    </Step>
  )
}

export default SingleAllocationTargetingDisabledStep
